import { SelectVendastaAccountModalProps } from './SelectVendastaAccountModal';
import { openModal } from '@core/components/ModalStack';

export async function openSelectVendastaAccountModal(props: SelectVendastaAccountModalProps) {
  const { SelectVendastaAccountModal } = await import('./SelectVendastaAccountModal');

  openModal(SelectVendastaAccountModal, props);
}
